export const isSafari = () => {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

export const isIOSDevice = () => {
	return /iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
};

export const isFirefox = typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);
